// stores/useSupportStore.ts
import { create } from 'zustand';
import axiosInstance from '../api/axiosInstance';

type SupportState = {
  sploading: boolean;
  sperror: string | null;
  spsuccess: boolean;
  submitSupport: (params: { user_id: string; email: string; subject:string; text: string }) => Promise<void>;
};

export const useSupportStore = create<SupportState>((set) => ({
  sploading: false,
  sperror: null,
  spsuccess: false,

  submitSupport: async ({ user_id, email,subject, text }) => {
    set({ sploading: true, sperror: null, spsuccess: false });

    try {
      const payload = {
        user_id,
        email,
        title: subject,
        desc: text,
      };

      await axiosInstance.post('/supportSubmit', payload);

      set({ sploading: false, spsuccess: true });
    } catch (err: any) {
      const message = err.response?.data?.message || 'Failed to send message.';
      set({ sploading: false, sperror: message });
    }
  },
}));
